import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBoard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"board, moodboard, layout, template"} maskId="square-filled-radius-0-stroke-1-IconBoard"><path d="M3 21V3H11V21L3 21Z" fill="currentColor"/><path d="M12 21L21 21V12.5H12V21Z" fill="currentColor"/><path d="M21 11.5V3H12V11.5H21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBoard;
